const WorksiteNameColumn = ({ des_worksite, address, city }) => {
  const hasAName = des_worksite.trim().toUpperCase() !== `${address}  - ${city}`.trim().toUpperCase();
  return (
    <div>
      <div>{hasAName? des_worksite: address}</div>

      {hasAName && (
        <div className="mt-1 text-xs">{address}</div>
      )}
    </div>
  );
};

export default WorksiteNameColumn;
